import styled from "styled-components";

export const PageHeaderWrapper = styled.div`
  display: flex;
  padding: 5px;
  flex-wrap: wrap;
  align-items: center;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.03em;
  text-align: left;
  width: fit-content;
  border: 1px solid ${(props) => (props.hasError ? "#e6725e" : "none")};
  border-radius: 5px;
`;

export const PageName = styled.a`
  font-size: 13px;
  color: ${(props) => props.color || "#444"};
`;

export const SponsoredMessage = styled.div`
  display: flex;
  font-size: 11px;
  color: ${(props) => props.color || "#999999"};
`;

export const PageLogo = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 30px;
  margin-right: 12px;
`;

export const SponsoredLogo = styled.img`
  height: 16px;
  width: 16px;
  margin-left: 6px;
`;
